export const formatLocalDate = (date) => {
  const dateObj = new Date(date);
  const timeZoneOffset = dateObj.getTimezoneOffset() * 60000;
  const localISOTime = new Date(dateObj.getTime() - timeZoneOffset).toISOString().split('T')[0];
  return localISOTime;
};
